
export default function AboutMe() {
  return (
    <section className="py-20 px-4 bg-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-orange-100 rounded-full blur-3xl opacity-30"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-red-100 rounded-full blur-3xl opacity-30"></div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-4">
            ABOUT ME
          </h2>
          <div className="w-24 h-2 bg-gradient-to-r from-orange-500 to-red-500 mx-auto rounded-full"></div>
        </div>
        
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-r from-orange-500 to-red-500 rounded-3xl opacity-20 blur-xl"></div>
            <div className="relative aspect-[3/4] rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://static.readdy.ai/image/83c31d00f47a619d4f0a515f0b3bc954/a7bbc39100e38d3606d59f6c3c42d52a.jpeg"
                alt="Jazzlyn Vassilatos - Volleyball Player"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                <p className="text-white font-bold text-2xl">Jazzlyn Vassilatos</p>
                <p className="text-orange-400 text-lg">#7</p>
              </div>
            </div>
          </div>
          
          <div className="space-y-6">
            <div className="bg-gradient-to-br from-orange-50 to-red-50 p-6 rounded-2xl border-l-4 border-orange-500">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center">
                  <i className="ri-user-fill text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">Personal Info</h3>
              </div>
              <div className="grid grid-cols-2 gap-4 text-gray-700">
                <div>
                  <p className="text-sm text-gray-500">Name</p>
                  <p className="font-semibold">Jazzlyn Vassilatos</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Age</p>
                  <p className="font-semibold">14 Years</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Graduation</p>
                  <p className="font-semibold">Class of 2028</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Position</p>
                  <p className="font-semibold">Libero</p>
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-6 rounded-2xl border-l-4 border-blue-500">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center">
                  <i className="ri-team-fill text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">Current Teams</h3>
              </div>
              <div className="space-y-2 text-gray-700">
                <div className="flex items-center gap-2">
                  <i className="ri-basketball-fill text-orange-500"></i>
                  <p><strong className="text-gray-900">Club:</strong> Push the Rock Academy 14U</p>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-school-fill text-blue-500"></i>
                  <p><strong className="text-gray-900">School:</strong> Notre Dame of East Stroudsburg</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-6 rounded-2xl border-l-4 border-purple-500">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-purple-500 rounded-full flex items-center justify-center">
                  <i className="ri-history-fill text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">Previous Teams</h3>
              </div>
              <div className="space-y-2 text-gray-700">
                <div className="flex items-center gap-2">
                  <i className="ri-basketball-line text-purple-500"></i>
                  <p><strong className="text-gray-900">Force Volleyball:</strong> 12U &amp; 13U</p>
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-2xl border-l-4 border-green-500">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center">
                  <i className="ri-line-chart-fill text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">Physical Stats</h3>
              </div>
              <div className="grid grid-cols-3 gap-4 text-center">
                <div>
                  <p className="text-2xl font-bold text-gray-900">5'3"</p>
                  <p className="text-sm text-gray-500">Height</p>
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">24"</p>
                  <p className="text-sm text-gray-500">Vertical</p>
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">3.4</p>
                  <p className="text-sm text-gray-500">GPA</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-yellow-50 to-amber-50 p-6 rounded-2xl border-l-4 border-yellow-500">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-yellow-500 rounded-full flex items-center justify-center">
                  <i className="ri-tent-fill text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">Volleyball Camps</h3>
              </div>
              <div className="space-y-2 text-gray-700">
                <div className="flex items-center gap-2">
                  <i className="ri-calendar-check-fill text-yellow-600"></i>
                  <p><strong className="text-gray-900">2023:</strong> East Stroudsburg University Volleyball Camp</p>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-calendar-check-fill text-yellow-600"></i>
                  <p><strong className="text-gray-900">2023:</strong> Millersville Volleyball Camp</p>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-calendar-check-fill text-yellow-600"></i>
                  <p><strong className="text-gray-900">2024:</strong> East Stroudsburg University Volleyball Camp</p>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-calendar-check-fill text-yellow-600"></i>
                  <p><strong className="text-gray-900">2024:</strong> Millersville Volleyball Camp</p>
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-red-50 to-orange-50 p-6 rounded-2xl border-l-4 border-red-500">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center">
                  <i className="ri-heart-fill text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">My Volleyball Journey</h3>
              </div>
              <p className="text-gray-700 leading-relaxed">
                Volleyball isn't just a sport for me—it's my passion and my future. I dream of playing at the collegiate level and beyond. Every practice, every game, every rep is a step toward that goal. I bring intensity, leadership, and a relentless work ethic to the court. My goal is to find a college program where I can contribute immediately while continuing to develop my skills and pursue academic excellence.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
